/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AccountShortInfo} from '../models/AccountShortInfo';
import type {Error} from '../models/Error';

export interface GetRecentlyViewedAccounts$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getRecentlyViewedAccountsRequest = createAction<PayloadData<void>>('GET_RECENTLY_VIEWED_ACCOUNTS__GET_RECENTLY_VIEWED_ACCOUNTS__REQUEST');
export const getRecentlyViewedAccountsSuccess = createAction<PayloadData<Array<AccountShortInfo>>>('GET_RECENTLY_VIEWED_ACCOUNTS__GET_RECENTLY_VIEWED_ACCOUNTS__SUCCESS');
export const getRecentlyViewedAccountsFailure = createAction<PayloadData<Error, void, true>>('GET_RECENTLY_VIEWED_ACCOUNTS__GET_RECENTLY_VIEWED_ACCOUNTS__FAILURE');

export const getRecentlyViewedAccountsActions = [
    getRecentlyViewedAccountsRequest,
    getRecentlyViewedAccountsSuccess,
    getRecentlyViewedAccountsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getRecentlyViewedAccounts = (config?: GetRecentlyViewedAccounts$Config) => {
    return {
        CALL_API: {
            types: getRecentlyViewedAccountsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/recently-viewed`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

